module.exports = __webpack_public_path__ + "img/box-arrow-in-up-right.67e79ee5.svg";